var Base = require('_js/base'),
  ko = require('knockout'),
  filter = require('lodash/filter'),
  find = require('lodash/find');

function MultiSelectSimple(params) {
  if (!params.checkedCallback) {
    throw 'Need to provide a callback for when checkboxes are checked';
  }
  var self = this;
  this.parent = params.parent;
  this.options = ko.observableArray(params.options || []);
  this.title = ko.observable(params.title || 'Vis alle');
  this.isActive = ko.observable(false);

  var answers = [];

  if (params.category()) {
    answers = params.category().split(',');
  }

  this.checkedOptions = ko.observableArray(answers);
  this.checkedOptions.subscribe(function(val) {
    params.checkedCallback(this.parent, this.checkedOptions());
    if (val.length === 0) {
      this.title('Vis alle');
    } else {
      this.title('Endre valg');
    }
  }, this);
  if (answers.length > 0) {
    this.title('Endre valg');
  }

  // Clicks outside the multiselect will close the dropdown.
  ko.postbox.subscribe('maincontent', function(newVal) {
    if (newVal === 'click') {
      self.isActive(false);
    }
  });
}

MultiSelectSimple.prototype = new Base();

MultiSelectSimple.prototype.init = function(element) {
  this.$element = $(element);
  // Clicks on the element will not trigger the closing of the multiselect.
  this.$element.on('click', function(e) {
    e.stopPropagation();
  });
};

MultiSelectSimple.prototype.removeParent = function(list, key) {
  return filter(list, function(item) {
    return item.Key !== key;
  });
};

MultiSelectSimple.prototype.hasChildrenSelected = function(list, keys) {
  var result = find(list, function(item) {
    for (var i = 0; i < keys.length; i++) {
      if (parseInt(keys[i], 10) === item.Key) {
        return true;
      }
    }
    return false;
  });
  return result !== undefined;
};

MultiSelectSimple.prototype.clearOptions = function() {
  this.checkedOptions([]);
};

MultiSelectSimple.prototype.toggleMultiSelect = function() {
  this.isActive(!this.isActive());
};

module.exports = MultiSelectSimple;
